export default {
  toDoSection: {
    id: 'onboarding_seller_modal_todo_section',
    defaultMessage: 'To do',
  },
  doneSection: {
    id: 'onboarding_seller_modal_done_section',
    defaultMessage: 'Done?',
  },
}
